// D10 LALA-RESUME (her YES, 2026-10-27): SHE COMES BACK TO HER LAST CONVERSATION, NOT A BLANK PAGE.
//
// #434/#435: a member's whole day of work was spread over twelve threads because every visit to Ask Lala opened a fresh one,
// and she believed it was lost. The page now reopens her newest thread on arrival. Pure (imports nothing), so a gate runs it.

export type ResumeRow = { id: number | string };

/**
 * Which thread to open on arrival, or null for the fresh page. Never when she came WITH a question or a handoff (those start
 * fresh, by design), never on a funnel arrival (that page has its own greeting), never twice in one visit, never with no
 * thread to open. `rows` arrive newest first (the server orders by updated_at DESC).
 */
export function resumeTarget({ rows, arrivingWithAsk, alreadyResumed }: { rows: ResumeRow[] | null | undefined; arrivingWithAsk: boolean; alreadyResumed: boolean }): number | null {
  if (alreadyResumed || arrivingWithAsk) return null;
  const first = Array.isArray(rows) ? rows[0] : null;
  const id = first ? Number(first.id) : NaN;
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
